"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./AgentButton.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var AgentButton = function AgentButton(_ref) {
  var icon = _ref.icon,
      id = _ref.id,
      type = _ref.type,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      children = _ref.children,
      color = _ref.color;
  return /*#__PURE__*/_react["default"].createElement("button", {
    id: id,
    onClick: onClick,
    className: "gcl-agent-btn ".concat(type, " ").concat(color),
    disabled: disabled
  }, icon && /*#__PURE__*/_react["default"].createElement("div", {
    className: 'gcl-agent-icon'
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: 'gcl-icon ' + icon
  })), children);
};

AgentButton.propTypes = {
  icon: _propTypes["default"].string,
  id: _propTypes["default"].string,
  type: _propTypes["default"].oneOf(['primary', 'secondary', 'tertiary']),
  onClick: _propTypes["default"].func.isRequired,
  disabled: _propTypes["default"].bool,
  color: _propTypes["default"].oneOf(['blue', 'red', 'yellow', 'green'])
};
AgentButton.defaultProps = {
  type: 'primary',
  onClick: function onClick() {
    return console.warn('no function was assigned as prop');
  },
  color: 'blue'
};
var _default = AgentButton;
exports["default"] = _default;